<script>
import PopinAnchor from "@/components/molecules/popin-anchor";

export default {
  name: "FideliteCarteInfo",
  components: {
    PopinAnchor
  }
};
</script>

<template>
  <PopinAnchor
    open-on-hover
    popin-size="sm"
    icon-name="info"
    icon-position="left"
    variant="primary"
    icon-color="primary"
    icon-color-hover="white"
    outline
    icon-size="xs"
    button-class="u-radius-full"
    infobulle
    position="bottom-left"
    class="u-ml-xxs"
  >
    <slot />
  </PopinAnchor>
</template>
